module.exports = __webpack_public_path__ + "img/industriezaun.c460f4f9.jpg";